import FontFaceObserver from 'fontfaceobserver';

export default {
    name: 'assets',

    hooks: {
        app: {
            loadAppData(data) {
                // TODO Might be improved
                // Wait for fonts loading to add custom fonts css file.
                data.page.vars.fonts &&
                    this.assets
                        .loadMultipleFonts(data.page.vars.fonts)
                        .then(() => {
                            document.body.classList.add('fonts-loaded');

                            data.assets.css.forEach((asset) => {
                                if (asset.deffer === 'main-fonts') {
                                    setTimeout(() => {
                                        this.assets.addStyle(
                                            asset.path,
                                            'preload'
                                        );
                                    });
                                }
                            });
                        });

                return 'complete';
            },
        },
    },

    methods: {
        app: {
            addScript(src) {
                let el = document.createElement('script');
                el.src = src;
                document.head.appendChild(el);
                return el;
            },

            addStyle(href, rel = null) {
                let el = this.assets.createStyleLinkElement();
                el.href = href;

                document.head.appendChild(el);
                return el;
            },

            createStyleLinkElement() {
                let el = document.createElement('link');
                el.setAttribute('rel', 'stylesheet');
                return el;
            },

            loadMultipleFonts(fonts) {
                let queue = [];

                fonts.forEach((fontName) => {
                    let font = new FontFaceObserver(fontName);
                    queue.push(font.load());
                });

                return Promise.all(queue);
            },
        },
    },
};
